import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { screenHeightLeftFromTop } from "Constants";
import LocaleStrings from "Languages";
import ExhibitorinsightMenuIcon from "./exhibitorinsight-menu-icon";
import TableContentTopExhibitors from "./table-content-top-exhibitor";
import TableContentTopTagsExhibitors from "./table-content-toptags-exhibitor";
import TableContentTopCountriesExhibitors from "./table-content-topcountries-exhibitor";
import TableContentMostsearchExhibitorinsight from "./table-content-mostsearch-exhibitorinsight";
import ExhibitorinsightEngmntBarChart from "./exhibitorinsight-engmnt-barchart";
import AnalyticsCommonHeader from "AnalyticscommonAnalyticscommon";

import {
  fetchExhibitorsinsightMostsearkeysTableData,
  fetchTopExhibitorTableData,
  fetchExhiToptagsTableData,
  fetchExhiTopCountriesTableData,
  fetchexhiengagementbBarChart,
} from "ExhibitorinsightActions";

import { exhibitorsinsightnoofexhicount } from "ExhibitorinsightNoofexhiAction";
import { exhibitorsinsightexhilistviewcount } from "ExhibitorinsightExhilistviewAction";
import { exhibitorsinsightexhiprofviewcount } from "ExhibitorinsightExhiprofviewAction";
import { exhibitorsinsightexhifavocount } from "ExhibitorinsightExhifavoAction";
import { exhibitorsinsightsearchcount } from "ExhibitorinsightExhisearchAction";

var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class ExhibitorsinsightInside extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      desc: LocaleStrings.analytics_text_preparing_analytics,
      loader: false,
    };
  }

  //
  componentDidMount() {
    this.props.exhibitorsinsightnoofexhicount(
      this.props.session,
      (exhibitorsinsightnoofexhiresponse) => {
        if (exhibitorsinsightnoofexhiresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.exhibitorsinsightexhilistviewcount(
      this.props.session,
      (exhibitorsinsightexhilistviewresponse) => {
        if (exhibitorsinsightexhilistviewresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.exhibitorsinsightexhiprofviewcount(
      this.props.session,
      (exhibitorsinsightexhiprofviewresponse) => {
        if (exhibitorsinsightexhiprofviewresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.exhibitorsinsightexhifavocount(
      this.props.session,
      (exhibitorsinsightexhifavoresponse) => {
        if (exhibitorsinsightexhifavoresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    // Call to fetch Number of searches done on exhibitor list (Count)
    this.props.exhibitorsinsightsearchcount(
      this.props.session,
      (exhibitorsinsightsearchcountResponse) => {
        if (exhibitorsinsightsearchcountResponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    //Most search keywords (related to exhibitors)
    this.props.fetchExhibitorsinsightMostsearkeysTableData(
      this.props.session,
      (fetchexhibitorsinsightmostsearkeystabledataResponse) => {
        if (fetchexhibitorsinsightmostsearkeystabledataResponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    // Top exhibitors (exhibitors profiles with most user engagement)
    this.props.fetchTopExhibitorTableData(
      this.props.session,
      (fetchtopexhibitortabledataResponse) => {
        if (fetchtopexhibitortabledataResponse.error === 0) {
          //this.setState({loading:false});
        }
      }
    );

    // Top Tags (top tags related to exhibitors)
    this.props.fetchExhiToptagsTableData(
      this.props.session,
      (fetchexhitoptagstabledataResponse) => {
        if (fetchexhitoptagstabledataResponse.error === 0) {
          //this.setState({loading:false});
          //this.setState({ loading: false });
        }
      }
    );

    // call to Top Countries (Countries from which top exhibitors belongs)
    this.props.fetchExhiTopCountriesTableData(
      this.props.session,
      (fetchexhitopcountriestabledataResponse) => {
        if (fetchexhitopcountriestabledataResponse.error === 0) {
          //this.setState({loading:false});
          this.setState({ loading: false });
        }
      }
    );

    // call to Exhibitors Engagement (Chart view of how actively the exhibitor feature has been use over the selected date range)
    this.props.fetchexhiengagementbBarChart(
      this.props.session,
      this.props.datePropsMainPg,
      (fetchexhiengagementbBarChartResponse) => {
        if (fetchexhiengagementbBarChartResponse.error === 0) {
          this.setState({ loading: false });
        }
      }
    );

    //this.setState({ loading: false });
  }

  //Arrow function for renderLoader
  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  // Arrow function for render Attendees Messaging menu divs
  rebderExhibitorinsightMenuIcons() {
    return _.map(
      this.props.exhibitorInsightMenu,
      (exhibitorInsightmenuItem) => {
        return (
          <ExhibitorinsightMenuIcon
            menu={exhibitorInsightmenuItem}
            key={exhibitorInsightmenuItem.key}
          />
        );
      }
    );
  }

  // Send function with props for barchartdate change
  onDateChartChangeFc(obj) {
    this.setState({ loader: !this.state.loader });
  }

  // Rerender All componets on this page
  mainCallback = () => {
    this.setState({ loading: true });

    this.props.exhibitorsinsightnoofexhicount(
      this.props.session,
      (exhibitorsinsightnoofexhiresponse) => {
        if (exhibitorsinsightnoofexhiresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.exhibitorsinsightexhilistviewcount(
      this.props.session,
      (exhibitorsinsightexhilistviewresponse) => {
        if (exhibitorsinsightexhilistviewresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.exhibitorsinsightexhiprofviewcount(
      this.props.session,
      (exhibitorsinsightexhiprofviewresponse) => {
        if (exhibitorsinsightexhiprofviewresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.exhibitorsinsightexhifavocount(
      this.props.session,
      (exhibitorsinsightexhifavoresponse) => {
        if (exhibitorsinsightexhifavoresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    // Call to fetch Number of searches done on exhibitor list (Count)
    this.props.exhibitorsinsightsearchcount(
      this.props.session,
      (exhibitorsinsightsearchcountResponse) => {
        if (exhibitorsinsightsearchcountResponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    //Most search keywords (related to exhibitors)
    this.props.fetchExhibitorsinsightMostsearkeysTableData(
      this.props.session,
      (fetchexhibitorsinsightmostsearkeystabledataResponse) => {
        if (fetchexhibitorsinsightmostsearkeystabledataResponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    // Top exhibitors (exhibitors profiles with most user engagement)
    this.props.fetchTopExhibitorTableData(
      this.props.session,
      (fetchtopexhibitortabledataResponse) => {
        if (fetchtopexhibitortabledataResponse.error === 0) {
          //this.setState({loading:false});
        }
      }
    );

    // Top Tags (top tags related to exhibitors)
    this.props.fetchExhiToptagsTableData(
      this.props.session,
      (fetchexhitoptagstabledataResponse) => {
        if (fetchexhitoptagstabledataResponse.error === 0) {
          //this.setState({loading:false});
          //this.setState({ loading: false });
        }
      }
    );

    // call to Top Countries (Countries from which top exhibitors belongs)
    this.props.fetchExhiTopCountriesTableData(
      this.props.session,
      (fetchexhitopcountriestabledataResponse) => {
        if (fetchexhitopcountriestabledataResponse.error === 0) {
          //this.setState({loading:false});
          this.setState({ loading: false });
        }
      }
    );

    // call to Exhibitors Engagement (Chart view of how actively the exhibitor feature has been use over the selected date range)
    this.props.fetchexhiengagementbBarChart(
      this.props.session,
      this.props.datePropsMainPg,
      (fetchexhiengagementbBarChartResponse) => {
        if (fetchexhiengagementbBarChartResponse.error === 0) {
          this.setState({ loading: false });
        }
      }
    );
  };

  render() {
    let { deviceSize } = this.props;

    return (
      <div className="panel noborder-panel">
        {/* Header section */}
        {!this.state.loading ? (
          <AnalyticsCommonHeader
            finishOperationsCallback={this.mainCallback}
            callFrom="Exhibitors Insights"
            xchart={this.onDateChartChangeFc.bind(this)}
          />
        ) : (
          ""
        )}

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              {this.renderLoader()}
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <div>
              <ul className="nav nav-pills dashboardNavPill">
                {this.rebderExhibitorinsightMenuIcons()}
              </ul>
              <div className="mt-20"></div>
              <div className="panel-body ">
                {this.props.exhibarchart ? (
                  <ExhibitorinsightEngmntBarChart
                    exhibarchart={this.props.exhibarchart}
                    newprop={this.state.loader}
                  />
                ) : (
                  ""
                )}

                <TableContentTopExhibitors />
                <TableContentMostsearchExhibitorinsight />
                <div className="row">
                  <div className="col-lg-6">
                    <TableContentTopCountriesExhibitors />
                  </div>
                  <div className="col-lg-6">
                    <TableContentTopTagsExhibitors />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var { session, user, exhibitorInsightMenu, exhibitorsinsightSelectedItem } =
    state;

  var totalnooffexhi = state.exhibitorsinsightTotalNoofexhi
    ? state.exhibitorsinsightTotalNoofexhi
    : [];
  var totalexhilistview = state.exhibitorsinsightTotalExhilistview
    ? state.exhibitorsinsightTotalExhilistview
    : [];
  var totalexhiprofview = state.exhibitorsinsightTotalExhiprofview
    ? state.exhibitorsinsightTotalExhiprofview
    : [];
  var totalexhifavo = state.exhibitorsinsightTotalExhifavo
    ? state.exhibitorsinsightTotalExhifavo
    : [];
  var exhimostsearkeyslist = state.exhibitorsinsightMostsearkeysTablelist
    ? state.exhibitorsinsightMostsearkeysTablelist
    : [];
  var topexhilist = state.exhibitorsinsightTopexhiTablelist
    ? state.exhibitorsinsightTopexhiTablelist
    : [];
  var toptagsexhilist = state.exhibitorsinsightToptagsexhiTablelist
    ? state.exhibitorsinsightToptagsexhiTablelist
    : [];
  var topexhicountries = state.exhibitorsinsightTopcountriesTablelist
    ? state.exhibitorsinsightTopcountriesTablelist
    : [];
  //var exhibarchart = (state.exhibitorsinsightengagementbarChart && state.exhibitorsinsightengagementbarChart.response &&  state.exhibitorsinsightengagementbarChart.response.length > 0)
  var exhibarchart = state.exhibitorsinsightengagementbarChart
    ? state.exhibitorsinsightengagementbarChart.response
    : [];
  var totalexhisearch = state.exhibitorsinsightTotalExhisearch
    ? state.exhibitorsinsightTotalExhisearch.response
    : [];
  var datePropsMainPg = state.analyticscommondatepropsreducer;

  //componentDidMount()
  return {
    session,
    user,
    deviceSize: state.deviceSize,
    exhibitorInsightMenu,
    exhibitorsinsightSelectedItem,
    totalnooffexhi,
    totalexhilistview,
    totalexhiprofview,
    totalexhifavo,
    exhimostsearkeyslist,
    topexhilist,
    toptagsexhilist,
    topexhicountries,
    exhibarchart,
    datePropsMainPg,
    totalexhisearch,
  };
}

// Export with connect
export default connect(mapStateToProps, {
  exhibitorsinsightnoofexhicount,
  exhibitorsinsightexhilistviewcount,
  exhibitorsinsightexhiprofviewcount,
  exhibitorsinsightexhifavocount,
  fetchExhibitorsinsightMostsearkeysTableData,
  fetchTopExhibitorTableData,
  fetchExhiToptagsTableData,
  fetchExhiTopCountriesTableData,
  fetchexhiengagementbBarChart,
  exhibitorsinsightsearchcount,
})(ExhibitorsinsightInside);
